module.exports = __webpack_public_path__ + "img/N660-2.8562b4a7.png";